import { createContext, useContext, useState } from "react";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [token,         setToken]         = useState(localStorage.getItem("token"));
  const [role,          setRole]          = useState(localStorage.getItem("role"));
  const [name,          setName]          = useState(localStorage.getItem("name"));
  const [email,         setEmail]         = useState(localStorage.getItem("email"));
  const [emailVerified, setEmailVerified] = useState(localStorage.getItem("emailVerified") === "true");

  const login = ({ token, role, name, email: emailProp, emailVerified: ev }) => {
    setToken(token);
    setRole(role);
    setName(name);
    if (emailProp !== undefined)  setEmail(emailProp);
    if (ev !== undefined)         setEmailVerified(!!ev);

    localStorage.setItem("token", token);
    localStorage.setItem("role",  role);
    localStorage.setItem("name",  name || "");
    if (emailProp)         localStorage.setItem("email", emailProp);
    if (ev !== undefined)  localStorage.setItem("emailVerified", String(!!ev));
  };

  const updateEmailVerified = (verified) => {
    setEmailVerified(!!verified);
    localStorage.setItem("emailVerified", String(!!verified));
  };

  const logout = () => {
    setToken(null);
    setRole(null);
    setName(null);
    setEmail(null);
    setEmailVerified(false);
    localStorage.clear();
  };

  return (
    <AuthCtx.Provider
      value={{
        token,
        role,
        name,
        email,
        emailVerified,
        isAdmin:      role === "admin" || role === "superadmin",
        isSuperAdmin: role === "superadmin",
        isManager:    role === "admin",
        isAgent:      role === "agent",
        login,
        logout,
        updateEmailVerified,
      }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
